import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';

export type LineItemState = {
  readonly isDeletingCustomsItem: boolean;
  readonly isDeletingLineItem: boolean;
};

const lineItemInitialState: LineItemState = {
  isDeletingCustomsItem: false,
  isDeletingLineItem: false,
};

const lineItemReducer = (
  state: LineItemState = lineItemInitialState,
  action: ActionTypes,
): LineItemState => {
  switch (action.type) {
    case ActionKeys.LINE_ITEMS_DELETE:
      return {
        ...state,
        isDeletingLineItem: true,
      };
    case ActionKeys.LINE_ITEMS_DELETE_ERROR:
    case ActionKeys.LINE_ITEMS_DELETE_SUCCESS:
      return {
        ...state,
        isDeletingLineItem: false,
      };

    case ActionKeys.CUSTOMS_ITEM_DELETE:
      return {
        ...state,
        isDeletingCustomsItem: true,
      };
    case ActionKeys.CUSTOMS_ITEM_DELETE_ERROR:
    case ActionKeys.CUSTOMS_ITEM_DELETE_SUCCESS:
      return {
        ...state,
        isDeletingCustomsItem: false,
      };

    default:
      return state;
  }
};

export default lineItemReducer;
